import { createContext, useState } from 'react';
import { OrderStatus } from '../../common/enums/enums';

export const ApprovalsContext = createContext({
  pageNumber: 1,
  searchQuery: '',
  servicesCheckedStatus: {},

  markServiceAsApproved: serviceId => {},
  markServiceAsDeclined: serviceId => {},

  setPageNumber: pageNumber => {},
  setSearchQuery: searchQuery => {},

  orderToApproveOrDecline: null,
  setOrderToApproveOrDecline: order => {},

  showSuccessSnackBar: false,
  showErrorSnackBar: false,
  setShowSuccessSnackBar: () => {},
  setShowErrorSnackBar: () => {},
  errorMessage: '',
  setErrorMessage: () => {},
});

export const ApprovalsProvider = ({ children }) => {
  const [servicesCheckedStatus, setServicesCheckedStatus] = useState({});
  const [pageNumber, _setPageNumber] = useState(1);
  const [searchQuery, _setSearchQuery] = useState('');
  const [orderToApproveOrDecline, setOrderToApproveOrDecline] = useState(null);
  const [showSuccessSnackBar, setShowSuccessSnackBar] = useState(false);
  const [showErrorSnackBar, setShowErrorSnackBar] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const markServiceAsDeclined = serviceId => {
    setServicesCheckedStatus(prev => ({
      ...prev,
      [serviceId]: OrderStatus.declined,
    }));
  };

  const markServiceAsApproved = serviceId => {
    setServicesCheckedStatus(prev => ({
      ...prev,
      [serviceId]: OrderStatus.approved,
    }));
  };

  const setPageNumber = _pageNumber => {
    _setPageNumber(_pageNumber);
  };

  const setSearchQuery = _searchQuery => {
    if (searchQuery === _searchQuery) return;

    _setPageNumber(1);
    _setSearchQuery(_searchQuery);
  };

  return (
    <ApprovalsContext.Provider
      value={{
        servicesCheckedStatus,
        markServiceAsApproved,
        markServiceAsDeclined,
        pageNumber,
        setPageNumber,
        searchQuery,
        setSearchQuery,
        orderToApproveOrDecline,
        setOrderToApproveOrDecline,
        showSuccessSnackBar,
        showErrorSnackBar,
        setShowSuccessSnackBar,
        setShowErrorSnackBar,
        errorMessage,
        setErrorMessage,
      }}
    >
      {children}
    </ApprovalsContext.Provider>
  );
};
